function FreeShippingIcon({ className }) {
  return (
    <svg
      className="h-full w-full"
      width="101"
      height="100"
      viewBox="0 0 101 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.0731 63.3337C40.9078 63.3337 50.5017 53.7818 50.5017 41.9989C50.5017 30.216 40.9078 20.6641 29.0731 20.6641C17.2384 20.6641 7.64453 30.216 7.64453 41.9989C7.64453 53.7818 17.2384 63.3337 29.0731 63.3337Z"
        fill="#A1C323"
        fill-opacity="0.4"
      />
      <path
        d="M74.1884 84.1609C78.2038 84.1609 81.4589 80.92 81.4589 76.9222C81.4589 72.9244 78.2038 69.6836 74.1884 69.6836C70.1731 69.6836 66.918 72.9244 66.918 76.9222C66.918 80.92 70.1731 84.1609 74.1884 84.1609Z"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M62.9531 45.9883H76.1721C77.6659 45.9883 79.5496 47.2544 80.1379 48.6205L84.1036 56.5172C85.9701 60.2339 89.3912 61.7817 89.3912 61.7817C93.1242 63.6401 93.3569 67.1146 93.3569 68.2846V74.9429C93.3569 76.3972 92.1738 77.5751 90.7131 77.5751H85.4255"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <ellipse
        cx="74.8517"
        cy="77.5787"
        rx="0.793144"
        ry="0.789673"
        fill="#2F6132"
      />
      <path
        d="M72.207 51.2539V60.4667H81.4604"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M62.9544 49.9375V77.576H39.1602"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.2969 35.4609H62.9539V45.9899"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.0087 77.5767H14.043V35.4609H19.3306"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <ellipse
        cx="28.5861"
        cy="77.5826"
        rx="0.793141"
        ry="0.789669"
        fill="#2F6132"
      />
      <path
        d="M28.5861 84.1651C32.2364 84.1651 35.1956 81.2189 35.1956 77.5845C35.1956 73.9501 32.2364 71.0039 28.5861 71.0039C24.9357 71.0039 21.9766 73.9501 21.9766 77.5845C21.9766 81.2189 24.9357 84.1651 28.5861 84.1651Z"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M36.8911 43.1001C36.6124 43.1001 36.3998 43.0231 36.2531 42.8691C36.1064 42.7151 36.0331 42.4988 36.0331 42.2201V36.6541H34.0861C33.8588 36.6541 33.6828 36.5918 33.5581 36.4671C33.4334 36.3424 33.3711 36.1701 33.3711 35.9501C33.3711 35.7228 33.4334 35.5504 33.5581 35.4331C33.6828 35.3084 33.8588 35.2461 34.0861 35.2461H39.6851C39.9124 35.2461 40.0884 35.3084 40.2131 35.4331C40.3378 35.5504 40.4001 35.7228 40.4001 35.9501C40.4001 36.1701 40.3378 36.3424 40.2131 36.4671C40.0884 36.5918 39.9124 36.6541 39.6851 36.6541H37.7381V42.2201C37.7381 42.4988 37.6648 42.7151 37.5181 42.8691C37.3788 43.0231 37.1698 43.1001 36.8911 43.1001Z"
        fill="#2F6132"
      />
      <path
        d="M30.0744 43.122C29.7664 43.122 29.4511 43.0963 29.1284 43.045C28.8131 43.001 28.5088 42.935 28.2154 42.847C27.9294 42.759 27.6728 42.649 27.4454 42.517C27.2841 42.429 27.1704 42.3153 27.1044 42.176C27.0384 42.0293 27.0128 41.8827 27.0274 41.736C27.0494 41.5893 27.1044 41.461 27.1924 41.351C27.2878 41.2337 27.4051 41.1603 27.5444 41.131C27.6911 41.0943 27.8524 41.12 28.0284 41.208C28.3291 41.3767 28.6554 41.5013 29.0074 41.582C29.3668 41.6627 29.7224 41.703 30.0744 41.703C30.6098 41.703 30.9911 41.6223 31.2184 41.461C31.4458 41.2923 31.5594 41.0833 31.5594 40.834C31.5594 40.6213 31.4788 40.4527 31.3174 40.328C31.1561 40.2033 30.8738 40.097 30.4704 40.009L29.2274 39.745C28.5234 39.5983 27.9991 39.349 27.6544 38.997C27.3171 38.6377 27.1484 38.1683 27.1484 37.589C27.1484 37.2223 27.2254 36.8887 27.3794 36.588C27.5334 36.2873 27.7498 36.027 28.0284 35.807C28.3071 35.587 28.6371 35.4183 29.0184 35.301C29.4071 35.1837 29.8324 35.125 30.2944 35.125C30.7051 35.125 31.1084 35.1763 31.5044 35.279C31.9004 35.3743 32.2488 35.5173 32.5494 35.708C32.6961 35.796 32.7951 35.9097 32.8464 36.049C32.9051 36.181 32.9234 36.3167 32.9014 36.456C32.8868 36.588 32.8318 36.7053 32.7364 36.808C32.6484 36.9107 32.5348 36.9767 32.3954 37.006C32.2561 37.0353 32.0874 37.0023 31.8894 36.907C31.6474 36.7823 31.3908 36.6907 31.1194 36.632C30.8481 36.5733 30.5694 36.544 30.2834 36.544C29.9754 36.544 29.7114 36.5843 29.4914 36.665C29.2788 36.7457 29.1138 36.8593 28.9964 37.006C28.8864 37.1527 28.8314 37.3213 28.8314 37.512C28.8314 37.7247 28.9084 37.897 29.0624 38.029C29.2164 38.161 29.4841 38.2673 29.8654 38.348L31.1084 38.612C31.8271 38.766 32.3624 39.0153 32.7144 39.36C33.0664 39.6973 33.2424 40.1447 33.2424 40.702C33.2424 41.0687 33.1691 41.4023 33.0224 41.703C32.8758 41.9963 32.6631 42.2493 32.3844 42.462C32.1058 42.6747 31.7721 42.8397 31.3834 42.957C30.9948 43.067 30.5584 43.122 30.0744 43.122Z"
        fill="#2F6132"
      />
      <path
        d="M19.3365 43.1014C19.1311 43.1014 18.9625 43.0538 18.8305 42.9584C18.7058 42.8631 18.6251 42.7348 18.5885 42.5734C18.5591 42.4121 18.5921 42.2324 18.6875 42.0344L21.5035 35.8634C21.6208 35.6141 21.7601 35.4344 21.9215 35.3244C22.0828 35.2071 22.2698 35.1484 22.4825 35.1484C22.6951 35.1484 22.8821 35.2071 23.0435 35.3244C23.2048 35.4344 23.3405 35.6141 23.4505 35.8634L26.2885 42.0344C26.3838 42.2324 26.4168 42.4158 26.3875 42.5844C26.3655 42.7458 26.2921 42.8741 26.1675 42.9694C26.0428 43.0574 25.8815 43.1014 25.6835 43.1014C25.4341 43.1014 25.2398 43.0428 25.1005 42.9254C24.9685 42.8081 24.8511 42.6248 24.7485 42.3754L24.0885 40.8464L24.7705 41.3194H20.1835L20.8655 40.8464L20.2165 42.3754C20.1065 42.6321 19.9891 42.8191 19.8645 42.9364C19.7471 43.0464 19.5711 43.1014 19.3365 43.1014ZM22.4605 37.0624L21.0525 40.4174L20.7555 39.9884H24.1985L23.9015 40.4174L22.4825 37.0624H22.4605Z"
        fill="#2F6132"
      />
      <path
        d="M14.2909 43.1001C14.0122 43.1001 13.7959 43.0231 13.6419 42.8691C13.4952 42.7151 13.4219 42.4914 13.4219 42.1981V36.1371C13.4219 35.8511 13.4989 35.6311 13.6529 35.4771C13.8069 35.3231 14.0269 35.2461 14.3129 35.2461H18.0749C18.2949 35.2461 18.4599 35.3048 18.5699 35.4221C18.6872 35.5321 18.7459 35.6934 18.7459 35.9061C18.7459 36.1261 18.6872 36.2948 18.5699 36.4121C18.4599 36.5221 18.2949 36.5771 18.0749 36.5771H15.1269V38.4691H17.8329C18.0529 38.4691 18.2215 38.5278 18.3389 38.6451C18.4562 38.7551 18.5149 38.9164 18.5149 39.1291C18.5149 39.3418 18.4562 39.5068 18.3389 39.6241C18.2215 39.7414 18.0529 39.8001 17.8329 39.8001H15.1269V42.1981C15.1269 42.7994 14.8482 43.1001 14.2909 43.1001Z"
        fill="#2F6132"
      />
    </svg>
  )
}

export default FreeShippingIcon
